type ConnectivityListener = (reachable: boolean) => void;

class ConnectivityManager {
  private listeners = new Set<ConnectivityListener>();

  private backendReachable = typeof navigator !== 'undefined' ? navigator.onLine : false;

  private started = false;

  private notify() {
    for (const listener of this.listeners) {
      listener(this.backendReachable);
    }
  }

  subscribe(listener: ConnectivityListener): () => void {
    this.listeners.add(listener);
    listener(this.backendReachable);
    return () => this.listeners.delete(listener);
  }

  getSnapshot(): boolean {
    return this.backendReachable;
  }

  async markReachable(): Promise<void> {
    if (this.backendReachable) {
      return;
    }
    this.backendReachable = true;
    this.notify();
  }

  async markUnreachable(): Promise<void> {
    if (!this.backendReachable) {
      return;
    }
    this.backendReachable = false;
    this.notify();
  }

  start() {
    if (this.started || typeof window === 'undefined') {
      return;
    }
    this.started = true;

    const handleOnline = () => {
      void this.markReachable();
    };
    const handleOffline = () => {
      void this.markUnreachable();
    };
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      void this.markUnreachable();
    }
  }
}

export const connectivityManager = new ConnectivityManager();
